import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvoiceExport\GetBankAccountsListForExportController::__invoke
* @see app/Http/Controllers/InvoiceExport/GetBankAccountsListForExportController.php
* @route '/api/invoice/export/bank-account'
*/
const GetBankAccountsListForExportController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetBankAccountsListForExportController.url(options),
    method: 'get',
})

GetBankAccountsListForExportController.definition = {
    methods: ["get","head"],
    url: '/api/invoice/export/bank-account',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\InvoiceExport\GetBankAccountsListForExportController::__invoke
* @see app/Http/Controllers/InvoiceExport/GetBankAccountsListForExportController.php
* @route '/api/invoice/export/bank-account'
*/
GetBankAccountsListForExportController.url = (options?: RouteQueryOptions) => {
    return GetBankAccountsListForExportController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoiceExport\GetBankAccountsListForExportController::__invoke
* @see app/Http/Controllers/InvoiceExport/GetBankAccountsListForExportController.php
* @route '/api/invoice/export/bank-account'
*/
GetBankAccountsListForExportController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetBankAccountsListForExportController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\InvoiceExport\GetBankAccountsListForExportController::__invoke
* @see app/Http/Controllers/InvoiceExport/GetBankAccountsListForExportController.php
* @route '/api/invoice/export/bank-account'
*/
GetBankAccountsListForExportController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetBankAccountsListForExportController.url(options),
    method: 'head',
})

export default GetBankAccountsListForExportController